import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RewardCard } from '../components/RewardCard';
import { X, MapPin, Globe, Mail, Phone, Leaf, Award, Filter, Search } from 'lucide-react';
import { rewardsData } from '../utils/rewardsData';
const ProfilePreview = () => {
  const navigate = useNavigate();
  const [categoryFilter, setCategoryFilter] = useState('Tutti');
  const [costFilter, setCostFilter] = useState('Tutti');
  const [searchTerm, setSearchTerm] = useState('');
  // Profile data
  const profileData = {
    logo: 'https://blog.lasaponaria.it/hubfs/LaSaponaria-5.jpg',
    name: 'La Saponaria',
    tagline: 'Cosmetici Naturali e Sostenibili dal 2007',
    description: 'Marchio italiano di cosmetici naturali, biologici e consapevoli. Società Benefit dal 2023, produciamo cosmetici artigianali con ingredienti biologici certificati, packaging ecologico e produzione 100% italiana con energia rinnovabile.',
    website: 'https://www.lasaponaria.it/',
    email: 'info@lasaponaria.it',
    phone: '+39 0721 1706607',
    certifications: ['Biologico Certificato', 'Società Benefit', 'Cruelty Free', 'Vegan OK'],
    locations: ['Milano Centro', 'Roma Cola di Rienzo', 'Bologna', 'Firenze', 'Pesaro (Sede)', 'Milano Solari', 'Torino']
  };
  // Get active rewards only
  const activeRewards = Object.values(rewardsData).filter(reward => reward.status === 'Attivo');
  // Filter rewards
  const filteredRewards = activeRewards.filter(reward => {
    const matchesCategory = categoryFilter === 'Tutti' || reward.type === categoryFilter;
    const matchesCost = costFilter === 'Tutti' || costFilter === '0-50' && reward.cost <= 50 || costFilter === '51-100' && reward.cost > 50 && reward.cost <= 100 || costFilter === '100+' && reward.cost > 100;
    const matchesSearch = searchTerm === '' || reward.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesCost && matchesSearch;
  });
  const categories = ['Tutti', ...Array.from(new Set(activeRewards.map(r => r.type)))];
  return <div className="min-h-screen bg-gray-50" data-id="element-3673">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-30 shadow-sm" data-id="element-3674">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center" data-id="element-3675">
          <div className="flex items-center gap-3" data-id="element-3676">
            <img src={profileData.logo} alt={profileData.name} className="h-12 w-12 rounded-lg object-cover" data-id="element-3677" />
            <div data-id="element-3678">
              <h1 className="text-xl font-bold text-gray-900" data-id="element-3679">
                {profileData.name}
              </h1>
              <p className="text-sm text-gray-500" data-id="element-3680">Profilo Partner</p>
            </div>
          </div>
          <button onClick={() => navigate('/profile')} className="p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors" title="Chiudi anteprima" data-id="element-3681">
            <X className="h-5 w-5" data-id="element-3682" />
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-greenback to-green-700 text-white py-16" data-id="element-3683">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-3684">
          <img src={profileData.logo} alt={profileData.name} className="h-24 w-24 mx-auto mb-6 rounded-lg shadow-xl object-cover bg-white p-2" data-id="element-3685" />
          <h1 className="text-4xl md:text-5xl font-bold mb-3" data-id="element-3686">
            {profileData.name}
          </h1>
          <p className="text-xl md:text-2xl text-green-50" data-id="element-3687">
            {profileData.tagline}
          </p>

          {/* Certifications */}
          <div className="flex flex-wrap justify-center gap-2 mt-6" data-id="element-3688">
            {profileData.certifications.map((cert, index) => <span key={index} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/20 backdrop-blur-sm text-white rounded-full text-sm font-medium border border-white/30" data-id="element-3689">
                <Award className="h-3.5 w-3.5" data-id="element-3690" />
                {cert}
              </span>)}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="max-w-7xl mx-auto px-4 py-12" data-id="element-3691">
        <div className="bg-white rounded-lg border border-gray-200 p-8 shadow-sm" data-id="element-3692">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-3693">Chi Siamo</h2>
          <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3694">
            {profileData.description}
          </p>

          {/* Contact Info */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-6 border-t border-gray-200" data-id="element-3695">
            <a href={profileData.website} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-600 hover:text-greenback transition-colors" data-id="element-3696">
              <Globe className="h-5 w-5 flex-shrink-0" data-id="element-3697" />
              <span className="text-sm" data-id="element-3698">www.lasaponaria.it</span>
            </a>
            <a href={`mailto:${profileData.email}`} className="flex items-center gap-3 text-gray-600 hover:text-greenback transition-colors" data-id="element-3699">
              <Mail className="h-5 w-5 flex-shrink-0" data-id="element-3700" />
              <span className="text-sm" data-id="element-3701">{profileData.email}</span>
            </a>
            <a href={`tel:${profileData.phone}`} className="flex items-center gap-3 text-gray-600 hover:text-greenback transition-colors" data-id="element-3702">
              <Phone className="h-5 w-5 flex-shrink-0" data-id="element-3703" />
              <span className="text-sm" data-id="element-3704">{profileData.phone}</span>
            </a>
          </div>
        </div>
      </section>

      {/* Sustainability Section */}
      <section className="max-w-7xl mx-auto px-4 pb-12" data-id="element-3705">
        <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-lg border border-green-200 p-8" data-id="element-3706">
          <div className="flex items-start gap-4" data-id="element-3707">
            <Leaf className="h-8 w-8 text-green-600 flex-shrink-0 mt-1" data-id="element-3708" />
            <div data-id="element-3709">
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-3710">
                Impegno per la Sostenibilità
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-3711">
                <li className="flex items-start gap-3" data-id="element-3712">
                  <span className="text-green-600 mt-0.5 text-lg" data-id="element-3713">✓</span>
                  <span data-id="element-3714">
                    Produzione 100% artigianale e italiana con energia
                    rinnovabile
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3715">
                  <span className="text-green-600 mt-0.5 text-lg" data-id="element-3716">✓</span>
                  <span data-id="element-3717">
                    Ingredienti biologici certificati e filiere etiche fair
                    trade
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3718">
                  <span className="text-green-600 mt-0.5 text-lg" data-id="element-3719">✓</span>
                  <span data-id="element-3720">
                    Packaging plastic-free e opzioni zero-waste (cosmetici
                    solidi, ricariche)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3721">
                  <span className="text-green-600 mt-0.5 text-lg" data-id="element-3722">✓</span>
                  <span data-id="element-3723">
                    Prodotti biodegradabili che non inquinano fiumi, mari e
                    laghi
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section className="max-w-7xl mx-auto px-4 pb-12" data-id="element-3724">
        <div className="bg-white rounded-lg border border-gray-200 p-8 shadow-sm" data-id="element-3725">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-3726">
            Dove Trovarci
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-3727">
            {profileData.locations.map((location, index) => <div key={index} className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg border border-gray-200" data-id="element-3728">
                <MapPin className="h-4 w-4 text-greenback flex-shrink-0" data-id="element-3729" />
                <span className="text-sm text-gray-700" data-id="element-3730">{location}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* Rewards Section */}
      <section className="max-w-7xl mx-auto px-4 pb-16" data-id="element-3731">
        <div className="mb-8" data-id="element-3732">
          <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-3733">
            Premi Disponibili
          </h2>
          <p className="text-gray-600" data-id="element-3734">
            {filteredRewards.length} premi attivi che puoi riscattare con i tuoi
            punti
          </p>
        </div>

        {/* Filters */}
        <div className="bg-white rounded-lg border border-gray-200 p-4 mb-6 shadow-sm" data-id="element-3735">
          <div className="flex flex-wrap gap-3" data-id="element-3736">
            {/* Search */}
            <div className="relative flex-1 min-w-[200px]" data-id="element-3737">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" data-id="element-3738" />
              <input type="text" placeholder="Cerca premio..." className="w-full rounded-lg border border-gray-300 pl-10 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-greenback" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-3739" />
            </div>

            {/* Category Filter */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2" data-id="element-3740">
              <Filter className="mr-2 h-4 w-4 text-gray-500" data-id="element-3741" />
              <select className="bg-transparent text-sm focus:outline-none" value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)} data-id="element-3742">
                {categories.map(cat => <option key={cat} value={cat} data-id="element-3743">
                    {cat}
                  </option>)}
              </select>
            </div>

            {/* Cost Filter */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2" data-id="element-3744">
              <Filter className="mr-2 h-4 w-4 text-gray-500" data-id="element-3745" />
              <select className="bg-transparent text-sm focus:outline-none" value={costFilter} onChange={e => setCostFilter(e.target.value)} data-id="element-3746">
                <option value="Tutti" data-id="element-3747">Tutti i costi</option>
                <option value="0-50" data-id="element-3748">0-50 punti</option>
                <option value="51-100" data-id="element-3749">51-100 punti</option>
                <option value="100+" data-id="element-3750">100+ punti</option>
              </select>
            </div>
          </div>
        </div>

        {/* Rewards Grid */}
        {filteredRewards.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3751">
            {filteredRewards.map(reward => <RewardCard key={reward.id} reward={reward} isPreview={true} data-id="element-3752" />)}
          </div> : <div className="text-center py-12 bg-white rounded-lg border border-gray-200" data-id="element-3753">
            <p className="text-gray-500" data-id="element-3754">
              Nessun premio trovato con i filtri selezionati.
            </p>
          </div>}
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8" data-id="element-3755">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-3756">
          <p className="text-gray-400 text-sm" data-id="element-3757">
            © 2024 {profileData.name}. Tutti i diritti riservati.
          </p>
        </div>
      </footer>
    </div>;
};
export default ProfilePreview;